import { useSelector } from "react-redux";

import { selectSubscriptionId } from "@/auth/authSlice";

export const MAKERS_SUBSCRIPTION = 1;
export const FREELANCE_SUBSCRIPTION = 2;
export const TEAM_SUBSCRIPTION = 3;
export const ENTERPRISE_SUBSCRIPTION = 5;

const featureEnabled = {
    // Project
    client_owner: [
        MAKERS_SUBSCRIPTION,
        TEAM_SUBSCRIPTION,
        ENTERPRISE_SUBSCRIPTION,
    ],
    owner_id: [MAKERS_SUBSCRIPTION, TEAM_SUBSCRIPTION, ENTERPRISE_SUBSCRIPTION],
    project_type_id: [
        MAKERS_SUBSCRIPTION,
        TEAM_SUBSCRIPTION,
        ENTERPRISE_SUBSCRIPTION,
    ],
    legal_entity_id: [MAKERS_SUBSCRIPTION],
    persons: [MAKERS_SUBSCRIPTION, TEAM_SUBSCRIPTION, ENTERPRISE_SUBSCRIPTION],
    forecast: [MAKERS_SUBSCRIPTION],
    internal_budget: [MAKERS_SUBSCRIPTION, TEAM_SUBSCRIPTION],
    comments: [MAKERS_SUBSCRIPTION, TEAM_SUBSCRIPTION, ENTERPRISE_SUBSCRIPTION],

    // Bid
    xodo: [MAKERS_SUBSCRIPTION],
    topSheetProducers: [
        MAKERS_SUBSCRIPTION,
        TEAM_SUBSCRIPTION,
        ENTERPRISE_SUBSCRIPTION,
    ],

    // Account
    manageLegalEntity: [
        FREELANCE_SUBSCRIPTION,
        TEAM_SUBSCRIPTION,
        ENTERPRISE_SUBSCRIPTION,
    ],
    manageOrganizations: [
        MAKERS_SUBSCRIPTION,
        TEAM_SUBSCRIPTION,
        ENTERPRISE_SUBSCRIPTION,
    ],

    // AI
    aiIntake: [
        FREELANCE_SUBSCRIPTION,
        TEAM_SUBSCRIPTION,
        ENTERPRISE_SUBSCRIPTION,
    ],

    // Actualize
    actualize: [
        MAKERS_SUBSCRIPTION,
        TEAM_SUBSCRIPTION,
        ENTERPRISE_SUBSCRIPTION,
    ],
};

export default function SubscriptionComponent({ feature, children }) {
    const subscriptionId = useSelector(selectSubscriptionId);
    return feature in featureEnabled &&
        featureEnabled[feature].includes(subscriptionId)
        ? children
        : null;
}
